<template>
  <main class="deactivate-shopping-page">
    <section class="hero-section">
      <header class="hero-section__text">
        <h1 class="hero-section__text__title">
          O <span>Shopping Casar.com</span> foi desativado
        </h1>

        <p class="hero-section__text__description">
          Estamos evoluindo a plataforma do Casar.com e, por isso, o
          <strong>Shopping Casar.com foi desativado</strong>
        </p>
      </header>

      <img class="hero-section__image" :src="PinkCart" alt="Ilustração do Shopping Casar.com" />
    </section>

    <section class="info-section">
      <div class="info-section__container">
        <article class="info-section__container__block">
          <h2>O que isso significa na prática?</h2>
          <p>No momento, não é possível realizar novas compras no Shopping Casar.</p>
          <p>Porém, todas as compras realizadas antes da desativação continuam normalmente e contam
            com suporte completo do time Casar até a conclusão do processo.</p>
        </article>

        <article class="info-section__container__block">
          <h2>O que muda agora?</h2>
          <ul>
            <li>O Shopping Casar fica indisponível</li>
            <li>Outras funcionalidades do Casar.com seguem funcionando normalmente</li>
            <li>Novas soluções estão em desenvolvimento</li>
          </ul>
        </article>
      </div>
    </section>

    <section class="cta-section">
      <p>
        Estamos trabalhando para oferecer experiências cada vez melhores para você e seus convidados.
        Se tiver qualquer dúvida, nosso time está pronto para ajudar.
      </p>
      <div class="cta-section__buttons">
        <a href="/carteira">
          <button class="cta-section__buttons__wallet" type="button">
            Ir para minha carteira
          </button>
        </a>
        <a target="__blank" href="https://ajuda.casar.com/support/home">
          <button class="cta-section__buttons__support" type="button">
            Falar com o suporte
          </button>
        </a>
      </div>
    </section>
  </main>
</template>

<script>
import PinkCart from '@/assets/img/deactivate-shopping/pink-cart.png'

export default {
  name: 'DeactivateShoppingPage',

  data() {
    return {
      PinkCart
    }
  }
}
</script>

<style lang="scss" scoped>
.deactivate-shopping-page {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 32px 0;
  gap: 40px;
  margin-top: 110px;

  @media (max-width: 900px) {
    padding: 48px 0;
  }
}

.hero-section {
  display: flex;
  align-items: center;
  flex-direction: row;
  max-width: 837px;
  gap: 16px;
  
  @media (max-width: 900px) {
    padding: 0px 24px;
    flex-direction: column-reverse;
  }

  &__text {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 16px;

    @media (max-width: 900px) {
      text-align: center;
    }

    &__title {
      color: #374455;
      font-size: 36px;
      font-weight: 700;

      span {
        color: #E583A2;
      }
    }

    &__description {
      color: #5D758D;
      font-size: 18px;
      font-weight: 400;

      strong {
        color: #4E637B;
        font-weight: 700;
      }
    }
  }

  &__image {
    width: 192px;
    height: 192px;
    transform: rotate(-14deg);
    transform-origin: top left;
    margin-right: 48px;
  }
}

.features-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;

  @media (max-width: 900px) {
    padding: 0px 24px;
  }

  &__content {
    max-width: 840px;
    flex-direction: row;
    display: flex;
    gap: 24px;

    @media (max-width: 900px) {
      flex-direction: column;
    }

    &__card {
      padding: 24px;
      border-radius: 8px;
      outline: 1px #AEBDCB solid;
      display: flex;
      align-items: center;
      gap: 24px;

      &__icon {
        width: 40px !important;
        height: 40px !important;
        min-width: 40px;
        min-height: 40px;
        flex-shrink: 0;
        color: #E583A2;
      }

      &__texts {
        display: flex;
        flex-direction: column;
        gap: 8px;

        h3 {
          color: #5D758D;
          font-size: 16px;
          font-weight: 700;
        }

        p {
          color: #7D95AA;
          font-size: 16px;
          font-weight: 400;
        }
      }
    }
  }
}

.info-section {
  display: flex;
  justify-content: center;
  padding: 48px 0;
  width: 100%;
  background: #F6F7F9;

  @media (max-width: 900px) {
    padding: 48px 24px;
  }

  &__container {
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 840px;


    &__block {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      border-radius: 8px;
      gap: 8px;
      
      @media (max-width: 900px) {
        align-items: center;
      }

      h2 {
        color: #5D758D;
        font-size: 24px;
        font-weight: 700;
      }

      p,
      li {
        color: #7D95AA;
        font-size: 20px;
        list-style: disc;
        
        @media (max-width: 900px) {
          display: inline-block;
          text-align: center;
        }
      }

      ul {
        margin: 0;
        padding-left: 20px;
        
        @media (max-width: 900px) {
          display: inline-block;
          text-align: center;
        }
      }
    }

  }
}

.cta-section {
  max-width: 840px;
  padding: 40px 56px;
  background: #FCF3F6;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;

  p {
    text-align: center;
    color: #374455;
    font-size: 16px;
    font-weight: 700;
  }

  &__buttons {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 24px;


    @media (max-width: 900px) {
      flex-direction: column;
    }

    &__wallet {
      background: #E583A2;
      color: white;
      border: 1px solid #E583A2;
    }

    &__support {
      background: #fff;
      color: #5D758D;
      border: 1px solid #7D95AA;
    }

    button {
      padding: 16px 24px;
      border-radius: 100px;
      font-size: 16px;
      font-weight: 700;
      cursor: pointer;

      &:hover {
        opacity: 0.9;
      }
    }
  }

}
</style>
